export default __webpack_public_path__ + "static/media/img20200226_100709.778a78ec.jpg";